module.exports = __webpack_public_path__ + "static/media/noText.863e4ab6.png";